export const general = [
  { label: 'Superscript', code: 'x^2' },
  { label: 'Subscript', code: 'x_2' },
  { label: 'Parentheses', code: '(x)' },
  { label: 'Brackets', code: '\\{x\\}' },
  { label: 'Vertical bars', code: '|x|' },
  { label: 'Addition', code: 'x + y' },
  { label: 'Subtraction', code: 'x - y' },
  { label: 'Multiplication', code: 'z \\times y' },
  { label: 'Division', code: 'z \\div y' },
  { label: 'Fraction', code: '\\frac{x}{y}' },
  { label: 'Square root', code: '\\sqrt x' },
  { label: 'Sine', code: '\\sin' },
  { label: 'Cosine', code: '\\cos' },
  { label: 'Tangent', code: '\\tan' },
  { label: 'Infinity', code: '\\infty' },
  { label: 'Factorial', code: 'n!' },
  { label: 'Limits', code: '\\lim_{x\\to\\infty}' },
  { label: 'Integrals', code: '\\int_{y}^x i' },
  { label: 'Sums', code: '\\sum_{n=1}^{\\infty} 2-n' },
  { label: 'Alpha', code: '\\alpha; A' },
  { label: 'Beta', code: '\\beta; B' },
  { label: 'Gamma', code: '\\gamma; \\Gamma' },
  { label: 'Delta', code: '\\delta; \\Delta' },
  { label: 'Epsilon', code: '\\epsilon; E' },
  { label: 'Zeta', code: '\\zeta; Z' },
  { label: 'Eta', code: '\\eta; H' },
  { label: 'Theta', code: '\\theta; \\Theta' },
  { label: 'Kappa', code: '\\kappa; K' },
  { label: 'Lambda', code: '\\lambda; \\Lambda' },
  { label: 'Mu', code: '\\mu; M' },
  { label: 'Pi', code: '\\pi; \\Pi' },
  { label: 'Rho', code: '\\rho; R' },
  { label: 'Sigma', code: '\\sigma; \\Sigma' },
  { label: 'Tau', code: '\\tau; T' },
  { label: 'Upsilon', code: '\\upsilon; \\Upsilon' },
  { label: 'Phi', code: '\\phi; \\Phi' },
  { label: 'Chi', code: '\\chi; X' },
  { label: 'Psi', code: '\\psi; \\Psi' },
  { label: 'Omega', code: '\\omega; \\Omega' }
];
